// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (max-width: 452px) {
  .pagelayout {
    background-color: #FFFFFF;
    padding: 26px 12px 2px;
    width: 100%;
    height: 100%;
  }
}
@media screen and (min-width: 453px) {
  .pagelayout {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    min-height: 700px;
    max-height: 834px;
    min-width: 526px;
    border-radius: 30px;
    background-color: #FFFFFF;
    box-shadow: -2px 4px 16px 5px #BFBFBF20;
    padding: 24px 28px 28px;
    overflow: hidden;
  }
  .cashierPageLayout {
    padding: 26px 20px  20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Layout/style.less"],"names":[],"mappings":"AAAA;EACI;IACI,yBAAA;IACA,sBAAA;IACA,WAAA;IACA,YAAA;EACN;AACF;AAEA;EACI;IACI,kBAAA;IACA,QAAA;IACA,SAAA;IACA,gCAAA;IACA,iBAAA;IACA,iBAAA;IACA,gBAAA;IACA,mBAAA;IACA,yBAAA;IACA,uCAAA;IACA,uBAAA;IACA,gBAAA;EAAN;EAGE;IACI,wBAAA;EADN;AACF","sourcesContent":["@media screen and (max-width: 452px) {\n    .pagelayout {\n        background-color: #FFFFFF;\n        padding: 26px 12px 2px;\n        width: 100%;\n        height: 100%;\n    }    \n}\n\n@media screen and (min-width: 453px) {\n    .pagelayout {\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        min-height: 700px;\n        max-height: 834px;\n        min-width: 526px;\n        border-radius: 30px;\n        background-color: #FFFFFF;\n        box-shadow: -2px 4px 16px 5px #BFBFBF20;\n        padding: 24px 28px 28px;\n        overflow: hidden;\n    }\n    \n    .cashierPageLayout {\n        padding: 26px 20px  20px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
